module.exports = __webpack_public_path__ + "static/logo-05653ae09aec859431a9bb650e0acd69.png";